import { z } from "zod/v4";

const errorObject = z.object({
  statusCode: z.number(),
  statusName: z.string(),
  errorMessage: z.string(),
  traceId: z.string().optional(),
  source: z.string(),
});
type VolumeApiErrorObject = z.infer<typeof errorObject>;

const isVolumeApiError = (error: unknown): error is VolumeApiErrorObject => {
  return errorObject.safeParse(error).success;
};

export class VolumeApiError extends Error {
  public statusCode: number;
  public statusName: string;
  public errorMessage: string;
  public source: string;
  public traceId: string | undefined;
  constructor(error: unknown) {
    super();
    if (!isVolumeApiError(error)) {
      throw new Error("Invalid volume api error");
    }
    this.statusCode = error.statusCode;
    this.statusName = error.statusName;
    this.errorMessage = error.errorMessage;
    this.traceId = error.traceId;
    this.source = error.source;
    this.message = error.errorMessage;
  }

  public static isVolumeApiError(
    error: unknown,
  ): error is VolumeApiErrorObject {
    return isVolumeApiError(error);
  }
}
